import React from "react";
import Chip from '@material-ui/core/Chip';
import Tooltip from "@material-ui/core/Tooltip";

const StatusCell = (rowData) => {

  return (
    <React.Fragment>
      <span>{rowData.status}</span>
      <br/>
      {rowData.verification_email_status && rowData.status==="challenge" && (
      <Tooltip title={`${(rowData.challenge_info||{}).code}`}>
        <Chip label={`${rowData.verification_email_status}`} size="small" color="primary"/>
      </Tooltip>
      )}
    </React.Fragment>
  );
};

export default StatusCell;
